var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckAudit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#10B981",
  d: "M16.859 2.58A16.3 16.3 0 0 1 10.024.242a1.64 1.64 0 0 0-1.715 0A16.267 16.267 0 0 1 1.474 2.58 1.64 1.64 0 0 0 0 4.214V9.1a10.11 10.11 0 0 0 5.198 8.835l3.169 1.76a1.64 1.64 0 0 0 1.598 0l3.17-1.76A10.11 10.11 0 0 0 18.333 9.1V4.214A1.64 1.64 0 0 0 16.86 2.58"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.219 13.266a1.2 1.2 0 0 1-.797-.306l-2.849-2.544a1.2 1.2 0 0 1-.34-1.297 1.21 1.21 0 0 1 1.065-.809 1.2 1.2 0 0 1 .869.305l1.976 1.764 3.95-4.233a1.199 1.199 0 0 1 2.074.785c.01.32-.105.63-.323.864l-4.75 5.09a1.2 1.2 0 0 1-.875.38"
})));
export default SvgCheckAudit;